export default __webpack_public_path__ + "static/media/1.0d7ec0cf.jpg";